<div class="text-center otp_Text">
  <ng-container *ngIf="orderEditModalPageOne">
    <div class="f-32 fw-600 mb-3 mt-5"></div>
    <!-- <div class="fw-bold mb-3 f-14">Enter the 4-Digit Verification Code</div> -->
    <div class="fw-500 f-24 text-digit">
      {{ "The 4-Digit Verification Code has been sent to the Manager's e-mail" | translate | async }}
    </div>
    <div class="mb-4">
      <ng-otp-input
        class="input_theme"
        #ngOtpInput
        (onInputChange)="changeOtp($event)"
        [config]="configTwo"
      ></ng-otp-input>
    </div>
    <span class="text-danger f-w-5">{{ otpErrorMsg }}</span>
    <div>

      <button
        class="f-14 fw-700 btn-black"
        [disabled]="!buttonApprove"
        (click)="nextPageFunc()"
      >
        <span *ngIf="otpStateManage" class="f-18 fw-500 btn-black text-bold"
          >{{ "Please wait..." | translate | async }}</span
        >
        <span *ngIf="!otpStateManage" class="f-18 fw-500 btn-black text-bold"
          >{{ "VERIFY" | translate | async }}</span
        >
      </button>
      <div class="">
        <h4>
          <p class="text-center f-16 fw-600 text-digit">
            {{ "RE-SEND CODE IN" | translate | async }}
            <!-- <span class="text-black">{{
              timeToVerify | date : "mm:ss"
            }}</span> -->
            <span class="text-black">{{ timerDisplay }}</span>
          </p>
        </h4>
      </div>
    </div>

    <button
      class="f-16 fw-600 btn"
      [disabled]="timeToVerify > 0"
      (click)="resendOtpEditOrderFunc()"
      style="border: none"
    >
      {{ "Resend OTP" | translate | async }}
    </button>
  </ng-container>
</div>

<div class="">
  <ng-container *ngIf="orderEditModalPageTwo && !orderEditModalPageThree">
    <div>
      <div>
        <div class="f-16 fw-600 mt-3 mb-3">{{ "Select Transaction To Edit" | translate | async }}</div>
        <div
          class="col-12"
          *ngFor="
            let transaction of paymentReceipt.transactionIds;
            let i = index
          "
        >
          <div
            class="row trans-detaill"
            (click)="
              selectTransactionEditOrderFunc(transaction, paymentReceipt, i)
            "
            [ngClass]="
              !transaction.transactionSelected ? 'selectTran' : 'selectTran2'
            "
          >
            <div class="col-8 text-start">
              <div class="text-bold f-16 fw-500">{{ "Transaction ID" | translate | async }}</div>
              <!-- <div
                id="buttonTransaction"
                class="mt-2"
                style="
                  height: 31px;
                  font-size: 22.5px;
                  letter-spacing: -0.56px;
                  line-height: 31px;
                "
              >
                <span
                  *ngIf="
                    transaction.transactionTypeId == 16 ||
                    transaction.transactionTypeId == 17 ||
                    transaction.transactionTypeId == 18 ||
                    transaction.transactionTypeId == 19
                  "
                >
                  <img
                    style="height: 27.84px; width: 44.02px"
                    *ngIf="
                      (transaction.extraFields.cardType | lowercase) == 'mastercard'
                    "
                    src="../../../../../../assets/images/master.png"
                  />
                  <img
                    style="height: 27.84px; width: 44.02px"
                    *ngIf="(transaction.extraFields.cardType | lowercase) == 'amex'"
                    src="../../../../../../assets/images/amex.png"
                  />
                  <img
                    style="height: 27.84px; width: 44.02px"
                    *ngIf="
                      (transaction.extraFields.cardType | lowercase) == 'discvr'
                    "
                    src="../../../../../../assets/images/discover.png"
                  />
                  <img
                    style="height: 27.84px; width: 44.02px"
                    *ngIf="
                      (transaction.extraFields.cardType | lowercase) == 'discover'
                    "
                    src="../../../../../../assets/images/discover.png"
                  />
                  <img
                    style="height: 27.84px; width: 44.02px"
                    *ngIf="(transaction.extraFields.cardType | lowercase) == 'visa'"
                    src="../../../../../../assets/images/visa.png"
                  />
                  <span
                    style="
                      height: 31px;
                      width: 208px;
                      font-size: 22.5px;
                      letter-spacing: -0.56px;
                      line-height: 31px;
                    "
                    *ngIf="transaction.extraFields.cardType != 'UnknownCardType'"
                    >**** **** ****
                    {{ transaction.extraFields.maskedPAN | slice: -4 }}</span
                  >
                </span>
              </div> -->
              <div class="text-bold f-16 fw-500 mt-2">{{ "Transaction amount" | translate | async }}</div>
              <div class="text-bold f-16 fw-500 mt-2">{{ "Tips" | translate | async }}</div>
            </div>
            <div class="col-4 text-end fw-600 f-16">
              <div>{{ transaction.transactionNumber }}</div>
              <div id="buttonTransaction" class="mt-2">
                {{ currency
                }}{{ transaction.transactionAmount | number : "1.2-2" }}
              </div>
              <div>
                {{ currency
                }}{{ transaction.transactionTipAmount | number : "1.2-2" }}
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-12 my-5 text-end">
              <button
                id="buttonTransaction"
                class="btn-black w-100"
                (click)="
                  selectTransactionEditOrderFunc(transaction, paymentReceipt, i)
                "
              >
              <span class="f-18 fw-500 btn-black"> EDIT</span>
              </button>
            </div>
          </div> -->
        </div>
      </div>
      <div class="text-center btn-abs" style="left: 0 !important; right: 0 !important;">
        <button id="buttonTransaction" class="btn-green w-100">
          <span class="f-18 fw-600"> {{ "EDIT" | translate | async }}</span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="orderEditModalPageTwo && orderEditModalPageThree">
    <div class="col-12 mt-2">
      <div class="form-group select-emp">
        <label class="f-14 fw-600">{{ "Select employee" | translate | async }}</label>
        <div class="arrow-down-main">
          <select
            class="form-control f-16"
            id="employeeIds"
            [(ngModel)]="userSelected"
            (ngModelChange)="changeValueSelectFunc($event)"
          >
            <option disabled value="">{{ "Select Employee" | translate | async }}</option>
            <option
              *ngFor="let employee of employees"
              value="{{ employee.id }}"
            >
              {{ employee.name }}
            </option>
          </select>
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </div>
      <!-- [disabled]="paymentReceipt.orderId.orderSellStatus != 3" -->
      <div class="form-group my-3" *ngIf="paymentReceipt.transactionIds">
        <label class="f-14 fw-600">{{ "Tip" | translate | async }}</label>
        <input
          class="form-control text-start f-16"
          #currency
          [disabled]="paymentReceipt.transactionIds[0].transactionStatus == 7 || paymentReceipt.transactionIds[0].transactionStatus == 6"
          (ngModelChange)="change(currency)"
          currencyMask
          [(ngModel)]="tipAmount"
          [options]="{ prefix: nCurrency, decimal: '.'}"
          placeholder="{{ nCurrency + '0.00' }}"
        />
      </div>
      <span class="text-danger f-w-5">{{ errorMsg }}</span>
    </div>
    <div class="col-12 my-4 d-flex justify-content-end">
      <button
        class="btn-black w-100"
        [disabled]="chageLoader || errorMsg != ''"
        (click)="changeTipFunc()"
      >
        <span *ngIf="chageLoader" class="f-18 fw-700 btn-black"
          >{{ "Please wait..." | translate | async }}</span
        >
        <span *ngIf="!chageLoader" class="f-18 fw-700 btn-black">{{ "UPDATE" | translate | async }}</span>
      </button>
    </div>
  </ng-container>
</div>
